import { render, staticRenderFns } from "./ProfileValue.vue?vue&type=template&id=7bacbf64&"
import script from "./ProfileValue.vue?vue&type=script&lang=js&"
export * from "./ProfileValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports